import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/digitalBoard",
    name: "digitalBoard",
    redirect: {
        name: "digitalBoard",
    },
    meta,
    component: BasicLayout,
    children: [{
        path: 'basicInformation',
        name: 'basicInformation',
        meta: {
            title: '工作专班'
        },
        component: () =>
            import('@/pages/digitalBoard/basicInformation/index.vue')
    },{
        path: 'appealChannels',
        name: 'appealChannels',
        meta: {
            title: '诉求渠道'
        },
        component: () =>
            import('@/pages/digitalBoard/appealChannels/index.vue')
    },{
        path: 'serviceItems',
        name: 'serviceItems',
        meta: {
            title: '服务事项'
        },
        component: () =>
            import('@/pages/digitalBoard/serviceItems/index.vue')
    },{
        path: 'knowledgeGraph',
        name: 'knowledgeGraph',
        meta: {
            title: '知识图谱'
        },
        component: () =>
            import('@/pages/digitalBoard/knowledgeGraph/index.vue')
    },{
        path: 'livelihoodDemands',
        name: 'livelihoodDemands',
        meta: {
            title: '民生诉求职责清单'
        },
        component: () =>
            import('@/pages/digitalBoard/livelihoodDemands/index.vue')
    },{
        path: 'collaborationMechanism',
        name: 'collaborationMechanism',
        meta: {
            title: '协作机制'
        },
        component: () =>
            import('@/pages/digitalBoard/collaborationMechanism/index.vue')
    },],
};